module.exports = __webpack_public_path__ + "img/performance-school-icon4.1b53846e.png";